import axios from 'axios';
import { useQuery } from 'react-query';
import { useAuth } from './useAuth';

// Só tipos: o vite não resolve import de runtime de @webip/shared.
import type { AlertaSeveridade } from '@webip/shared/src/dto/alerta';

export const ALERTAS_QUERY_KEY = 'alertas';
export const ALERTAS_RESUMO_QUERY_KEY = 'alertas-resumo';

const PAPEIS_ALERTA = ['ADMIN', 'GESTOR'];

/** Firing por severidade — o badge do menu. Mesmo papel da tela (GESTOR+). */
export function useAlertasResumo() {
    const { user } = useAuth();
    const habilitado = !!user && PAPEIS_ALERTA.includes(user.papel);

    const query = useQuery(
        ALERTAS_RESUMO_QUERY_KEY,
        async () => {
            const res = await axios.get<{ result: Record<AlertaSeveridade, number> }>('/api/alerta/resumo', {
                withCredentials: true,
            });
            return res.data.result;
        },
        { enabled: habilitado, refetchInterval: 60_000, refetchOnWindowFocus: false },
    );

    const r = query.data ?? { critico: 0, aviso: 0, info: 0 };
    return { ...r, total: r.critico + r.aviso + r.info };
}
